// extracted by mini-css-extract-plugin
export default {"singleTransferStationInstrumentPage":"singleTransferStationInstrumentPage-UspbL","genericInstrumentPage":"genericInstrumentPage-sFtZ7","bodyContents":"bodyContents-QvJsG"};